import React, { useState, useEffect } from 'react';
import { CC } from '../constants';
import useDistrictHeroPhoto from '../hooks/useDistrictHeroPhoto';

export const CityBanner = ({ cityKey, displayCity, displayCountry, displayDistrict, height=300, children }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgErr, setImgErr] = useState(false);
  const [c1,c2,acc] = CC[cityKey]||CC.default;
  const heroSrc = useDistrictHeroPhoto(cityKey);
  // heroSrc changes when the city (or resolved district photo) changes — reset
  // the load/error flags each time, otherwise an error on any past city (or a
  // stale "loaded" flag) permanently hides the <img> or leaves it invisible
  // for every city switched to afterwards.
  useEffect(() => { setImgLoaded(false); setImgErr(false); }, [heroSrc]);
  const blds=[{x:0,w:50,h:240},{x:45,w:35,h:190},{x:76,w:60,h:270},{x:131,w:45,h:210},{x:171,w:70,h:290},{x:236,w:42,h:180},{x:273,w:58,h:260},{x:326,w:50,h:235},{x:371,w:65,h:280},{x:431,w:45,h:200},{x:471,w:70,h:265},{x:536,w:52,h:225},{x:583,w:48,h:250},{x:626,w:62,h:275},{x:683,w:40,h:198},{x:718,w:68,h:258},{x:781,w:44,h:188}];
  return (
    <div style={{ position:'relative', borderRadius:20, overflow:'hidden', height, background:`linear-gradient(135deg,${c1},${c2})` }}>
      {!imgErr && (
        <img key={heroSrc} src={heroSrc} alt={displayCity} fetchPriority="high"
          style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', opacity:imgLoaded?1:0, transition:'opacity 0.5s' }}
          onLoad={()=>setImgLoaded(true)} onError={()=>setImgErr(true)}/>
      )}
      {(!imgLoaded||imgErr) && (
        <svg width="100%" height={height} viewBox={`0 0 840 ${height}`} preserveAspectRatio="xMidYMid slice" style={{ position:'absolute', inset:0 }} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="bsky2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={c1}/><stop offset="100%" stopColor={c2}/></linearGradient>
          </defs>
          <rect width="840" height={height} fill="url(#bsky2)"/>
          {[...Array(50)].map((_,i)=><circle key={i} cx={(i*73+11)%840} cy={(i*47+7)%Math.round(height*0.5)} r={i%5===0?1.8:0.8} fill="white" opacity={0.1+(i%7)*0.04}/>)}
          <ellipse cx="420" cy={height} rx="360" ry="90" fill={acc} opacity="0.15"/>
          {blds.map((b,i)=>(
            <g key={i}>
              <rect x={b.x} y={height-b.h} width={b.w} height={b.h} fill={acc} opacity={0.07+i%3*0.02}/>
              {[...Array(Math.floor(b.h/25))].map((_,r)=>[...Array(Math.floor(b.w/14))].map((_,c)=>(i*5+r*3+c*7)%5!==0?<rect key={`${i}-${r}-${c}`} x={b.x+3+c*14} y={height-b.h+5+r*23} width={8} height={12} fill={acc} opacity={0.18+r%4*0.1}/>:null))}
            </g>
          ))}
        </svg>
      )}
      <div style={{ position:'absolute', inset:0, background:'linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.05) 55%, transparent 100%)' }}/>
      <div style={{ position:'absolute', bottom:0, left:0, right:0, padding:'20px 24px' }}>
        <p style={{ color: CC[cityKey]?.[2]||'#f59e0b', fontSize:11, fontWeight:900, letterSpacing:3, textTransform:'uppercase', margin:'0 0 4px' }}>{displayCountry}</p>
        <h2 style={{ color:'white', fontSize:38, fontWeight:900, lineHeight:1, margin:'0 0 6px', textShadow:'0 2px 12px rgba(0,0,0,0.5)' }}>{displayCity}</h2>
        {displayDistrict && (
          <p style={{ color:'rgba(255,255,255,0.85)', fontSize:15, fontWeight:700, margin:'0 0 8px', letterSpacing:0.5 }}>📍 {displayDistrict}</p>
        )}
        {children}
      </div>
    </div>
  );
};
